import * as Yup from 'yup';
import { useTranslation } from '../../hooks/useTranslation';

type TFunction = ReturnType<typeof useTranslation>['t'];

export const MEMBERS_POLICIES_SCHEMA = (t: TFunction) => {
    return Yup.object().shape({
        policy: Yup.object().shape({
            label: Yup.string().required(t('validationMessages.MEMBERS_POLICIES_SCHEMA.policy.label.required')),
            value: Yup.string().required(t('validationMessages.MEMBERS_POLICIES_SCHEMA.policy.value.required')),
        }),
        totalAmount: Yup.number()
            .integer(t('validationMessages.MEMBERS_POLICIES_SCHEMA.totalAmount.integer'))
            .min(0, t('validationMessages.MEMBERS_POLICIES_SCHEMA.totalAmount.min'))
            .required(t('validationMessages.MEMBERS_POLICIES_SCHEMA.totalAmount.required')),
    });
};
